import { useCallback, useState } from 'react';
import { useT } from '@/store';
import { OrderFilters } from '@/components/orders/OrderFilters';
import { OrdersTable } from '@/components/orders/OrdersTable';
import { CreateOrderDrawer } from '@/components/orders/CreateOrderDrawer';
import { OrderTemplatesPanel } from '@/components/orders/OrderTemplatesPanel';

const INITIAL_FILTERS = {
  search: '',
  status: '',
  driverId: '',
  dateFrom: '',
  dateTo: '',
  page: 1,
  pageSize: 25,
};

/**
 * Filter and pagination state lives here, at the one place that owns both
 * the filter bar and the table — the two have to agree on what "page 1"
 * means, and threading it through a store would make it global state that
 * nothing else reads.
 */
export function OrdersView() {
  const t = useT();
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [createOpen, setCreateOpen] = useState(false);

  const updateFilters = useCallback((patch) => setFilters((prev) => ({ ...prev, ...patch })), []);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <OrderFilters filters={filters} onChange={updateFilters} />
        <button type="button" className="btn btn-primary" onClick={() => setCreateOpen(true)}>
          {t('orders.newOrderBtn')}
        </button>
      </div>

      {/* Above the table, because it is what a dispatcher does FIRST: the
          morning's standing jobs go out, and then the table is where the
          rest of the day is watched. It renders as a small panel for a
          carrier with no standing customers, which is the honest cost of
          putting it on the path rather than behind a tab nobody opens. */}
      <OrderTemplatesPanel />

      <OrdersTable filters={filters} onFiltersChange={updateFilters} />
      <CreateOrderDrawer open={createOpen} onClose={() => setCreateOpen(false)} />
    </div>
  );
}
